import React from 'react';
export default class ModernResumeLanguage extends React.Component{

    getResumeBlock(data, index){

        return  <div data-v-37c786be="" className="section-skill" key={index}>
					{ data.name && <b data-v-37c786be="">{data.name}: </b> }
					{ data.proficiency && <span data-v-37c786be="">{data.proficiency}</span> }
				</div>

    }

    render(){
        return  <div data-v-37c786be="" className="section">
					<div data-v-37c786be="" className="section-left">
                    	<div data-v-37c786be="" className="section-headline">{this.props.title}</div>
					</div>
					<div data-v-37c786be="" className="section-right">
						<div data-v-37c786be="" className="section-item">
							{this.props.data.map((item, index) => {
							 	return this.getResumeBlock(item, index);
							})}
						</div>
                	</div>
				</div>
    }
}